DR.users = DR.users || {};
DR.users.struct = DR.users.struct || {};
DR.users.select = DR.users.select || {};
/** @extends {DR._Base} */
DR.users.struct.Extra = function(par){
	/** @private */
	this._t = 1234;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.isFirstGame)) this.isFirstGame = Boolean(par.isFirstGame);
	if(DR._Base.is(par.isTester)) this.isTester = Boolean(par.isTester);
};
DR._Base._types[1234] = DR.users.struct.Extra;
DR.users.struct.Extra[__P] = new DR._Base;
DR.users.struct.Extra[__P][__C] = DR.users.struct.Extra;
/** @type {Boolean} */
DR.users.struct.Extra.prototype.isFirstGame = null;
/** @type {Boolean} */
DR.users.struct.Extra.prototype.isTester = null;
 
/** @extends {DR._Base} */
DR.users.struct.Stats = function(par){
	/** @private */
	this._t = 1272;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.completedTasks)) this.completedTasks = (parseInt(par.completedTasks)||0);
	if(DR._Base.is(par.distance)) this.distance = (parseInt(par.distance)||0);
	if(DR._Base.is(par.games)) this.games = (parseInt(par.games)||0);
};
DR._Base._types[1272] = DR.users.struct.Stats;
DR.users.struct.Stats[__P] = new DR._Base;
DR.users.struct.Stats[__P][__C] = DR.users.struct.Stats;
/** @type {Number} */
DR.users.struct.Stats.prototype.completedTasks = null;
/** @type {Number} */
DR.users.struct.Stats.prototype.distance = null;
/** @type {Number} */
DR.users.struct.Stats.prototype.games = null;
 
/** @extends {DR._Base} */
DR.users.struct.User = function(par){
	/** @private */
	this._t = 1000;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.email)) this.email = String(par.email||'');
	if(DR._Base.is(par.extra)) this.extra = DR._Base.cast(par.extra);
	if(DR._Base.is(par.hasImage)) this.hasImage = Boolean(par.hasImage);
	if(DR._Base.is(par.hasRatedApp)) this.hasRatedApp = Boolean(par.hasRatedApp);
	if(DR._Base.is(par.hints)) this.hints = (parseInt(par.hints)||0);
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.isAdmin)) this.isAdmin = Boolean(par.isAdmin);
	if(DR._Base.is(par.isEmailValidated)) this.isEmailValidated = Boolean(par.isEmailValidated);
	if(DR._Base.is(par.isTempUser)) this.isTempUser = Boolean(par.isTempUser);
	if(DR._Base.is(par.language)) this.language = String(par.language||'');
	if(DR._Base.is(par.name)) this.name = String(par.name||'');
	if(DR._Base.is(par.preferredEventLanguages)){
		var tmp = [];
		for( var k in par.preferredEventLanguages ) tmp.push(String(par.preferredEventLanguages [k]||''));
		this.preferredEventLanguages = tmp;
	}
	if(DR._Base.is(par.registrationDate)) this.registrationDate = (parseInt(par.registrationDate)||0);
	if(DR._Base.is(par.stats)) this.stats = DR._Base.cast(par.stats);
	if(DR._Base.is(par.surname)) this.surname = String(par.surname||'');
};
DR._Base._types[1000] = DR.users.struct.User;
DR.users.struct.User.LANGUAGE_LV = "lv";
DR.users.struct.User.LANGUAGE_EN = "en";
DR.users.struct.User.LANGUAGE_ET = "et";
DR.users.struct.User.LANGUAGE_LT = "lt";
DR.users.struct.User[__P] = new DR._Base;
DR.users.struct.User[__P][__C] = DR.users.struct.User;
/** @type {String|null} */
DR.users.struct.User.prototype.email = null;
/** @type {DR.users.struct.Extra} */
DR.users.struct.User.prototype.extra = null;
/** @type {Boolean} */
DR.users.struct.User.prototype.hasImage = null;
/** @type {Boolean} */
DR.users.struct.User.prototype.hasRatedApp = null;
/** @type {Number|null} */
DR.users.struct.User.prototype.hints = null;
/** @type {Number} */
DR.users.struct.User.prototype.id = null;
/** @type {DR.roadgames.struct.Image} */
DR.users.struct.User.prototype.image = null;
/** @type {Boolean} */
DR.users.struct.User.prototype.isAdmin = null;
/** @type {Boolean} */
DR.users.struct.User.prototype.isEmailValidated = null;
/** @type {Boolean} */
DR.users.struct.User.prototype.isTempUser = null;
/** @type {String} */
DR.users.struct.User.prototype.language = null;
/** @type {String} */
DR.users.struct.User.prototype.name = null;
/** @type {Array.<String>} */
DR.users.struct.User.prototype.preferredEventLanguages = null;
/** @type {Number} */
DR.users.struct.User.prototype.registrationDate = null;
/** @type {DR.users.struct.Stats} */
DR.users.struct.User.prototype.stats = null;
/** @type {String} */
DR.users.struct.User.prototype.surname = null;
 
/** @extends {DR._Select} */
DR.users.select.User = function(){
	this._fields = {};
};
DR.users.select.User[__CL] = "Users__User";
DR.users.select.User[__P] = new DR._Select;
DR.users.select.User[__P][__C] = DR.users.select.User;
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.email = function(v){ this._fields.email = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.extra = function(v){ this._fields.extra = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.hasImage = function(v){ this._fields.hasImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.hasRatedApp = function(v){ this._fields.hasRatedApp = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.hints = function(v){ this._fields.hints = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.id = function(v){ this._fields.id = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.image = function(v){ this._fields.image = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.isAdmin = function(v){ this._fields.isAdmin = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.isEmailValidated = function(v){ this._fields.isEmailValidated = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.isTempUser = function(v){ this._fields.isTempUser = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.language = function(v){ this._fields.language = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.name = function(v){ this._fields.name = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.preferredEventLanguages = function(v){ this._fields.preferredEventLanguages = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.registrationDate = function(v){ this._fields.registrationDate = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.stats = function(v){ this._fields.stats = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.User} */
DR.users.select.User.prototype.surname = function(v){ this._fields.surname = !DR._Base.is(v) || !!v; return this; };
 
/** @extends {DR._Base} */
DR.users.struct.AuthRe = function(par){
	/** @private */
	this._t = 1055;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.apiKey)) this.apiKey = String(par.apiKey||'');
	if(DR._Base.is(par.user)) this.user = DR._Base.cast(par.user);
	if(DR._Base.is(par.wasTempUser)) this.wasTempUser = Boolean(par.wasTempUser);
};
DR._Base._types[1055] = DR.users.struct.AuthRe;
DR.users.struct.AuthRe[__P] = new DR._Base;
DR.users.struct.AuthRe[__P][__C] = DR.users.struct.AuthRe;
/** @type {String} */
DR.users.struct.AuthRe.prototype.apiKey = null;
/** @type {DR.users.struct.User} */
DR.users.struct.AuthRe.prototype.user = null;
/** @type {Boolean|null} */
DR.users.struct.AuthRe.prototype.wasTempUser = null;
 
/** @extends {DR._Base} */
DR.users.struct.DeleteProfileRe = function(par){
	/** @private */
	this._t = 1327;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.ok)) this.ok = Boolean(par.ok);
};
DR._Base._types[1327] = DR.users.struct.DeleteProfileRe;
DR.users.struct.DeleteProfileRe[__P] = new DR._Base;
DR.users.struct.DeleteProfileRe[__P][__C] = DR.users.struct.DeleteProfileRe;
/** @type {Boolean} */
DR.users.struct.DeleteProfileRe.prototype.ok = null;
 
/** @extends {DR._Base} */
DR.users.struct.EditProfileRe = function(par){
	/** @private */
	this._t = 1185;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.emailChanged)) this.emailChanged = Boolean(par.emailChanged);
	if(DR._Base.is(par.errors)){
		var tmp = {};
		for( var k in par.errors ) tmp[k] = String(par.errors [k]||'');
		this.errors = tmp;
	}
	if(DR._Base.is(par.user)) this.user = DR._Base.cast(par.user);
};
DR._Base._types[1185] = DR.users.struct.EditProfileRe;
DR.users.struct.EditProfileRe[__P] = new DR._Base;
DR.users.struct.EditProfileRe[__P][__C] = DR.users.struct.EditProfileRe;
/** @type {Boolean|null} */
DR.users.struct.EditProfileRe.prototype.emailChanged = null;
/** @type {Object.<String,String>} */
DR.users.struct.EditProfileRe.prototype.errors = null;
/** @type {DR.users.struct.User|null} */
DR.users.struct.EditProfileRe.prototype.user = null;
 
/** @extends {DR._Base} */
DR.users.struct.DraugiemAuthUrl = function(par){
	/** @private */
	this._t = 1058;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1058] = DR.users.struct.DraugiemAuthUrl;
DR.users.struct.DraugiemAuthUrl[__P] = new DR._Base;
DR.users.struct.DraugiemAuthUrl[__P][__C] = DR.users.struct.DraugiemAuthUrl;
/** @type {String} */
DR.users.struct.DraugiemAuthUrl.prototype.url = null;
 
/** @extends {DR._Base} */
DR.users.struct.MyData = function(par){
	/** @private */
	this._t = 1101;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
	if(DR._Base.is(par.user)) this.user = DR._Base.cast(par.user);
};
DR._Base._types[1101] = DR.users.struct.MyData;
DR.users.struct.MyData[__P] = new DR._Base;
DR.users.struct.MyData[__P][__C] = DR.users.struct.MyData;
/** @type {DR.teams.struct.Team|null} */
DR.users.struct.MyData.prototype.team = null;
/** @type {DR.users.struct.User} */
DR.users.struct.MyData.prototype.user = null;
 
/** @extends {DR._Select} */
DR.users.select.MyData = function(){
	this._fields = {};
};
DR.users.select.MyData[__CL] = "Users__MyData";
DR.users.select.MyData[__P] = new DR._Select;
DR.users.select.MyData[__P][__C] = DR.users.select.MyData;
/** @param {boolean} [v]
  * @return {DR.users.select.MyData} */
DR.users.select.MyData.prototype.team = function(v){ this._fields.team = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.users.select.MyData} */
DR.users.select.MyData.prototype.user = function(v){ this._fields.user = !DR._Base.is(v) || !!v; return this; };
 
/** @extends {DR._Base} */
DR.users.struct.RegisterRe = function(par){
	/** @private */
	this._t = 1183;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.apiKey)) this.apiKey = String(par.apiKey||'');
	if(DR._Base.is(par.errors)){
		var tmp = {};
		for( var k in par.errors ) tmp[k] = String(par.errors [k]||'');
		this.errors = tmp;
	}
	if(DR._Base.is(par.user)) this.user = DR._Base.cast(par.user);
};
DR._Base._types[1183] = DR.users.struct.RegisterRe;
DR.users.struct.RegisterRe[__P] = new DR._Base;
DR.users.struct.RegisterRe[__P][__C] = DR.users.struct.RegisterRe;
/** @type {String|null} */
DR.users.struct.RegisterRe.prototype.apiKey = null;
/** @type {Object.<String,String>} */
DR.users.struct.RegisterRe.prototype.errors = null;
/** @type {DR.users.struct.User|null} */
DR.users.struct.RegisterRe.prototype.user = null;
 
/** @extends {DR._Method} */
DR.users.AddAppRating = function(par){
	this.select = [];
	/** @private */
	this._t = 1283;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1283] = DR.users.AddAppRating;
DR.users.AddAppRating[__CL] = "Users__AddAppRating";
DR.users.AddAppRating.STATUS_NOT_RATED = 0;
DR.users.AddAppRating.STATUS_LIKED = 1;
DR.users.AddAppRating.STATUS_DIDNT_LIKE = 2;
DR.users.AddAppRating.STATUS_SKIPPED = 3;
DR.users.AddAppRating[__P] = new DR._Method;
DR.users.AddAppRating[__P][__C] = DR.users.AddAppRating;
/** @type {String|null} */
DR.users.AddAppRating.prototype.comment = null;
/** @type {Number} */
DR.users.AddAppRating.prototype.status = null;
/** @type {DR.roadgames.struct.Status} */
DR.users.AddAppRating.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.AuthWithMail = function(par){
	this.select = [];
	/** @private */
	this._t = 1056;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1056] = DR.users.AuthWithMail;
DR.users.AuthWithMail[__CL] = "Users__AuthWithMail";
DR.users.AuthWithMail[__P] = new DR._Method;
DR.users.AuthWithMail[__P][__C] = DR.users.AuthWithMail;
/** @type {String} */
DR.users.AuthWithMail.prototype.email = null;
/** @type {String} */
DR.users.AuthWithMail.prototype.password = null;
/** @type {DR.users.struct.AuthRe} */
DR.users.AuthWithMail.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.AuthWithSocial = function(par){
	this.select = [];
	/** @private */
	this._t = 1057;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1057] = DR.users.AuthWithSocial;
DR.users.AuthWithSocial[__CL] = "Users__AuthWithSocial";
DR.users.AuthWithSocial.SERVICE_DRAUGIEM = "draugiem";
DR.users.AuthWithSocial.SERVICE_GOOGLE = "google";
DR.users.AuthWithSocial.SERVICE_FACEBOOK = "facebook";
DR.users.AuthWithSocial.SERVICE_APPLE = "apple";
DR.users.AuthWithSocial[__P] = new DR._Method;
DR.users.AuthWithSocial[__P][__C] = DR.users.AuthWithSocial;
/** @type {String|null} */
DR.users.AuthWithSocial.prototype.affiliateId = null;
/** @type {String} */
DR.users.AuthWithSocial.prototype.service = null;
/** @type {String} */
DR.users.AuthWithSocial.prototype.token = null;
/** @type {DR.users.struct.AuthRe} */
DR.users.AuthWithSocial.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.CheckEmail = function(par){
	this.select = [];
	/** @private */
	this._t = 1200;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1200] = DR.users.CheckEmail;
DR.users.CheckEmail[__CL] = "Users__CheckEmail";
DR.users.CheckEmail[__P] = new DR._Method;
DR.users.CheckEmail[__P][__C] = DR.users.CheckEmail;
/** @type {String} */
DR.users.CheckEmail.prototype.email = null;
/** @type {DR.roadgames.struct.Status} */
DR.users.CheckEmail.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.DeleteProfile = function(par){
	this.select = [];
	/** @private */
	this._t = 1328;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1328] = DR.users.DeleteProfile;
DR.users.DeleteProfile[__CL] = "Users__DeleteProfile";
DR.users.DeleteProfile[__P] = new DR._Method;
DR.users.DeleteProfile[__P][__C] = DR.users.DeleteProfile;
/** @type {DR.users.struct.DeleteProfileRe} */
DR.users.DeleteProfile.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.DeletePushToken = function(par){
	this.select = [];
	/** @private */
	this._t = 1048;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1048] = DR.users.DeletePushToken;
DR.users.DeletePushToken[__CL] = "Users__DeletePushToken";
DR.users.DeletePushToken[__P] = new DR._Method;
DR.users.DeletePushToken[__P][__C] = DR.users.DeletePushToken;
/** @type {DR.roadgames.struct.Status} */
DR.users.DeletePushToken.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.EditProfile = function(par){
	this.select = [];
	/** @private */
	this._t = 1186;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1186] = DR.users.EditProfile;
DR.users.EditProfile[__CL] = "Users__EditProfile";
DR.users.EditProfile[__P] = new DR._Method;
DR.users.EditProfile[__P][__C] = DR.users.EditProfile;
/** @type {String|null} */
DR.users.EditProfile.prototype.email = null;
/** @type {String|null} */
DR.users.EditProfile.prototype.name = null;
/** @type {String|null} */
DR.users.EditProfile.prototype.password = null;
/** @type {String|null} */
DR.users.EditProfile.prototype.surname = null;
/** @type {DR.users.struct.EditProfileRe} */
DR.users.EditProfile.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.ForgotPassword = function(par){
	this.select = [];
	/** @private */
	this._t = 1060;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1060] = DR.users.ForgotPassword;
DR.users.ForgotPassword[__CL] = "Users__ForgotPassword";
DR.users.ForgotPassword[__P] = new DR._Method;
DR.users.ForgotPassword[__P][__C] = DR.users.ForgotPassword;
/** @type {String} */
DR.users.ForgotPassword.prototype.email = null;
/** @type {DR.roadgames.struct.Status} */
DR.users.ForgotPassword.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.GetDraugiemAuthUrl = function(par){
	this.select = [];
	/** @private */
	this._t = 1059;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1059] = DR.users.GetDraugiemAuthUrl;
DR.users.GetDraugiemAuthUrl[__CL] = "Users__GetDraugiemAuthUrl";
DR.users.GetDraugiemAuthUrl[__P] = new DR._Method;
DR.users.GetDraugiemAuthUrl[__P][__C] = DR.users.GetDraugiemAuthUrl;
/** @type {DR.users.struct.DraugiemAuthUrl} */
DR.users.GetDraugiemAuthUrl.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.GetMyData = function(par){
	this.select = [];
	/** @private */
	this._t = 1102;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1102] = DR.users.GetMyData;
DR.users.GetMyData[__CL] = "Users__GetMyData";
DR.users.GetMyData[__P] = new DR._Method;
DR.users.GetMyData[__P][__C] = DR.users.GetMyData;
/** @type {DR.users.struct.MyData} */
DR.users.GetMyData.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.GetProfile = function(par){
	this.select = [];
	/** @private */
	this._t = 1273;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1273] = DR.users.GetProfile;
DR.users.GetProfile[__CL] = "Users__GetProfile";
DR.users.GetProfile[__P] = new DR._Method;
DR.users.GetProfile[__P][__C] = DR.users.GetProfile;
/** @type {Number} */
DR.users.GetProfile.prototype.userId = null;
/** @type {DR.users.struct.User} */
DR.users.GetProfile.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.Register = function(par){
	this.select = [];
	/** @private */
	this._t = 1184;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1184] = DR.users.Register;
DR.users.Register[__CL] = "Users__Register";
DR.users.Register[__P] = new DR._Method;
DR.users.Register[__P][__C] = DR.users.Register;
/** @type {String|null} */
DR.users.Register.prototype.affiliateId = null;
/** @type {String} */
DR.users.Register.prototype.email = null;
/** @type {String} */
DR.users.Register.prototype.name = null;
/** @type {String} */
DR.users.Register.prototype.password = null;
/** @type {String|null} */
DR.users.Register.prototype.surname = null;
/** @type {DR.users.struct.RegisterRe} */
DR.users.Register.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.ResendEmailVerification = function(par){
	this.select = [];
	/** @private */
	this._t = 1182;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1182] = DR.users.ResendEmailVerification;
DR.users.ResendEmailVerification[__CL] = "Users__ResendEmailVerification";
DR.users.ResendEmailVerification[__P] = new DR._Method;
DR.users.ResendEmailVerification[__P][__C] = DR.users.ResendEmailVerification;
/** @type {DR.roadgames.struct.Status} */
DR.users.ResendEmailVerification.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.SavePreferredEventLanguages = function(par){
	this.select = [];
	this.languages = [];
	/** @private */
	this._t = 1316;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1316] = DR.users.SavePreferredEventLanguages;
DR.users.SavePreferredEventLanguages[__CL] = "Users__SavePreferredEventLanguages";
DR.users.SavePreferredEventLanguages[__P] = new DR._Method;
DR.users.SavePreferredEventLanguages[__P][__C] = DR.users.SavePreferredEventLanguages;
/** @type {Array.<String>} */
DR.users.SavePreferredEventLanguages.prototype.languages = null;
/** @type {DR.roadgames.struct.Status} */
DR.users.SavePreferredEventLanguages.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.SavePushToken = function(par){
	this.select = [];
	/** @private */
	this._t = 1047;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1047] = DR.users.SavePushToken;
DR.users.SavePushToken[__CL] = "Users__SavePushToken";
DR.users.SavePushToken[__P] = new DR._Method;
DR.users.SavePushToken[__P][__C] = DR.users.SavePushToken;
/** @type {String|null} */
DR.users.SavePushToken.prototype.bundleId = null;
/** @type {String} */
DR.users.SavePushToken.prototype.token = null;
/** @type {DR.roadgames.struct.Status} */
DR.users.SavePushToken.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.SetEmail = function(par){
	this.select = [];
	/** @private */
	this._t = 1181;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1181] = DR.users.SetEmail;
DR.users.SetEmail[__CL] = "Users__SetEmail";
DR.users.SetEmail[__P] = new DR._Method;
DR.users.SetEmail[__P][__C] = DR.users.SetEmail;
/** @type {String} */
DR.users.SetEmail.prototype.email = null;
/** @type {DR.users.struct.User} */
DR.users.SetEmail.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.VerifyEmail = function(par){
	this.select = [];
	/** @private */
	this._t = 1180;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1180] = DR.users.VerifyEmail;
DR.users.VerifyEmail[__CL] = "Users__VerifyEmail";
DR.users.VerifyEmail[__P] = new DR._Method;
DR.users.VerifyEmail[__P][__C] = DR.users.VerifyEmail;
/** @type {String} */
DR.users.VerifyEmail.prototype.hash = null;
/** @type {Number} */
DR.users.VerifyEmail.prototype.id = null;
/** @type {String} */
DR.users.VerifyEmail.prototype.key = null;
/** @type {DR.users.struct.AuthRe} */
DR.users.VerifyEmail.prototype.re = null;
 
/** @extends {DR._Method} */
DR.users.VerifyEmailChange = function(par){
	this.select = [];
	/** @private */
	this._t = 1187;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1187] = DR.users.VerifyEmailChange;
DR.users.VerifyEmailChange[__CL] = "Users__VerifyEmailChange";
DR.users.VerifyEmailChange[__P] = new DR._Method;
DR.users.VerifyEmailChange[__P][__C] = DR.users.VerifyEmailChange;
/** @type {String} */
DR.users.VerifyEmailChange.prototype.hash = null;
/** @type {Number} */
DR.users.VerifyEmailChange.prototype.id = null;
/** @type {String} */
DR.users.VerifyEmailChange.prototype.key = null;
/** @type {DR.users.struct.AuthRe} */
DR.users.VerifyEmailChange.prototype.re = null;
 
D.loaded();